export default {
  computed: {
    calendarConfig() {
      return {
        holidays: [],
        events: [],
        disableDates: [],
      };
    }
  }
};
